export const translations = {
  es: {
    nav: {
      espacio: "El Espacio",
      eventos: "Eventos",
      galeria: "Galería",
      servicios: "Servicios",
      testimonios: "Testimonios",
      contacto: "Contacto",
      solicitar: "Solicitar Información",
    },
    hero: {
      tagline: "Palacete Modernista · Sarrià · Barcelona",
      heading1: "Un espacio",
      heading2: "sin igual, verdadero, bello y bondadoso",
      subheading:
        "Historia, naturaleza y elegancia para experiencias que perduran en la memoria.",
      cta1: "Solicitar Información",
      cta2: "Conocer el Espacio",
      private_note:
        "Espacio privado · Solo eventos con reserva previa",
    },
    espacio: {
      caption: "El Espacio",
      heading: "Un palacete con alma",
      p1: "Torre Amat es una casa modernista del siglo XIX, declarada Patrimonio Histórico de Barcelona, ubicada en el corazón de Sarrià. Su arquitectura señorial, sus jardines románticos y su atmósfera única la convierten en el escenario perfecto para momentos extraordinarios.",
      p2: "Rodeada de vegetación centenaria y bañada de luz natural, Torre Amat ofrece una experiencia sensorial que difícilmente se encuentra en otro lugar de la ciudad. El aroma de las flores, el sonido del viento entre los árboles y la belleza serena de su arquitectura crean un ambiente de calma y distinción.",
      p3: "Este espacio no está abierto al público general. Cada evento es único, cuidado con atención personalizada y reservado solo para quienes buscan lo extraordinario.",
      feature1: "Patrimonio Histórico",
      feature1_desc: "Declarado Bien de Interés Histórico de Barcelona",
      feature2: "Jardín Romántico",
      feature2_desc: "Más de 100 m² de jardines en agricultura biodinámica",
      feature3: "Arquitectura Modernista",
      feature3_desc: "Palacete modernista original del siglo XIX conservado con todo su esplendor original",
      feature4: "Solo Eventos Privados",
      feature4_desc: "Atención personalizada y exclusiva",
      download_diptico: "Descargar Díptico",
      download_plano: "Descargar Plano",
    },
    eventos: {
      caption: "Tipos de Eventos",
      heading: "Cada celebración, única",
      subheading:
        "Torre Amat se adapta a la naturaleza de cada evento con la misma elegancia y dedicación.",
      boda: {
        title: "Bodas & Celebraciones",
        desc: "Un entorno romántico e íntimo para el día más importante de vuestra vida.",
      },
      corporativo: {
        title: "Eventos Corporativos",
        desc: "Presentaciones de producto, cenas de gala y reuniones ejecutivas en un marco incomparable.",
      },
      coctel: {
        title: "Cócteles & Recepciones",
        desc: "Recepciones elegantes entre jardines y arquitectura histórica.",
      },
      exposicion: {
        title: "Exposiciones & Desfiles",
        desc: "Un escenario artístico natural para muestras de moda, arte y cultura.",
      },
      privado: {
        title: "Celebraciones Privadas",
        desc: "Cumpleaños, aniversarios y reuniones familiares de alto nivel.",
      },
      capacidad: {
        title: "Capacidades por Espacio",
        espacio: "Espacio",
        banquete: "Banquete",
        coctel: "Cóctel",
        rows: [
          ["Planta + Jardín", "150", "180"],
          ["Planta entera", "80", "120"],
          ["Jardín", "100", "150"],
          ["Sala Noble", "60", "140"],
          ["Sala Kubala", "20", "40"],
          ["Sala Foronda", "20", "40"],
        ],
      },
    },
    galeria: {
      caption: "Galería",
      heading: "Imágenes que hablan por sí solas",
    },
    servicios: {
      caption: "Servicios",
      heading: "Todo lo que necesitas para un encuentro perfecto",
      items: [
        {
          title: "Coordinación de Eventos",
          desc: "Acompañamos cada detalle del evento desde la primera visita hasta el último brindis.",
        },
        {
          title: "Catering Premium",
          desc: "Gastronomía de autor con ingredientes de temporada y presentación impecable.",
        },
        {
          title: "Diseño Floral",
          desc: "Decoración floral artística integrada con la naturaleza del jardín.",
        },
        {
          title: "Sonido & Música",
          desc: "Equipo de sonido profesional y opciones de música en directo.",
        },
        {
          title: "Parking & Acceso",
          desc: "Información sobre acceso, parking cercano y accesibilidad para todos los invitados.",
        },
        {
          title: "Proveedores Premium",
          desc: "Red de partners exclusivos seleccionados por su calidad y experiencia.",
        },
      ],
    },
    testimonios: {
      caption: "Testimonios",
      heading: "Lo que dicen nuestros clientes",
      items: [
        {
          text: "Un lugar precioso, romántico y bien conservado. La atención fue exquisita y el jardín, simplemente mágico. Una experiencia que no olvidaremos.",
          author: "Marta & Pau",
          role: "Boda en Torre Amat",
        },
        {
          text: "Organizamos la presentación de nuestra nueva colección aquí y el espacio transmitió exactamente el lujo y la exclusividad que buscábamos. Perfecto.",
          author: "Equipo Creativo",
          role: "Evento Corporativo",
        },
        {
          text: "El ambiente es único en Barcelona. Los jardines, la arquitectura, la luz... todo crea una sensación de calma y elegancia que no encontrarás en ningún otro lugar.",
          author: "Anna G.",
          role: "Celebración Privada",
        },
        {
          text: "Desde el mercado artesanal que organizamos hasta la cena privada, Torre Amat siempre supera las expectativas. El equipo es cercano y profesional.",
          author: "Fundació Cultural",
          role: "Evento Cultural",
        },
      ],
    },
    ubicacion: {
      caption: "Cómo Llegar",
      heading: "Torre Amat, Sarrià",
      address: "Barrio de Sarrià-Sant Gervasi, Barcelona",
      transport: "Cómo llegar",
      transport_items: [
        { icon: "Train", label: "FGC", desc: "Ferrocarrils Generalitat de Catalunya (L6, S2, S1) — estación Sarrià (5 min a pie)" },
        { icon: "Bus", label: "Bus", desc: "Líneas 22, 64, 75 (parada Sarrià)" },
        { icon: "Car", label: "Coche", desc: "Parking en C/ Pedró de la Creu, 38 · BSM Porta de Sarrià (a 5 minutos a pie)" },
      ],
      private_note: "Espacio no abierto al público general. Acceso solo con reserva previa.",
    },
    contacto: {
      caption: "Contacto",
      heading: "Cuéntanos tu evento",
      subheading:
        "Escríbenos y te responderemos en menos de 24 horas para organizar una visita al espacio.",
      nombre: "Nombre completo",
      email: "Correo electrónico",
      telefono: "Teléfono (opcional)",
      tipo_evento: "Tipo de evento",
      fecha: "Fecha deseada",
      invitados: "Número aproximado de invitados",
      mensaje: "Mensaje adicional",
      enviar: "Escríbenos",
      sending: "Enviando...",
      success: "Mensaje enviado. Nos pondremos en contacto contigo pronto.",
      error: "Ha ocurrido un error. Por favor, inténtalo de nuevo.",
      email_direct: "info@torreamat.com",
      tipos: [
        "Boda",
        "Evento corporativo",
        "Cóctel / Recepción",
        "Exposición / Desfile",
        "Celebración privada",
        "Otro",
      ],
    },
    footer: {
      tagline: "Patrimonio Histórico de Barcelona",
      rights: "Todos los derechos reservados",
      private: "Espacio privado · Solo eventos con reserva",
    },
  },

  ca: {
    nav: {
      espacio: "L'Espai",
      eventos: "Esdeveniments",
      galeria: "Galeria",
      servicios: "Serveis",
      testimonios: "Testimonis",
      contacto: "Contacte",
      solicitar: "Sol·licitar Informació",
    },
    hero: {
      tagline: "Palauet Modernista · Sarrià · Barcelona",
      heading1: "Un espai",
      heading2: "únic, veritable, bell i bondadós",
      subheading:
        "Història, natura i elegància per a experiències que perduren en la memòria.",
      cta1: "Sol·licitar Informació",
      cta2: "Conèixer l'Espai",
      private_note: "Espai privat · Només esdeveniments amb reserva prèvia",
    },
    espacio: {
      caption: "L'Espai",
      heading: "Un palauet amb ànima",
      p1: "Torre Amat és una casa modernista del segle XIX, declarada Patrimoni Històric de Barcelona, ubicada al cor de Sarrià. La seva arquitectura senyorial, els seus jardins romàntics i la seva atmosfera única la converteixen en l'escenari perfecte per a moments extraordinaris.",
      p2: "Envoltada de vegetació centenària i banyada de llum natural, Torre Amat ofereix una experiència sensorial que difícilment es troba en un altre lloc de la ciutat. L'aroma de les flors, el so del vent entre els arbres i la bellesa serena de la seva arquitectura creen un ambient de calma i distinció.",
      p3: "Aquest espai no està obert al públic general. Cada esdeveniment és únic, cuidat amb atenció personalitzada i reservat només per a qui cerca l'extraordinari.",
      feature1: "Patrimoni Històric",
      feature1_desc: "Declarat Bé d'Interès Històric de Barcelona",
      feature2: "Jardí Romàntic",
      feature2_desc: "Més de 100 m² de jardins en agricultura biodinàmica",
      feature3: "Arquitectura Modernista",
      feature3_desc: "Palauet modernista original del segle XIX conservat amb tota la seva esplendor original",
      feature4: "Només Esdeveniments Privats",
      feature4_desc: "Atenció personalitzada i exclusiva",
      download_diptico: "Descarregar Díptic",
      download_plano: "Descarregar Plànol",
    },
    eventos: {
      caption: "Tipus d'Esdeveniments",
      heading: "Cada celebració, única",
      subheading:
        "Torre Amat s'adapta a la naturalesa de cada esdeveniment amb la mateixa elegància i dedicació.",
      boda: {
        title: "Noces & Celebracions",
        desc: "Un entorn romàntic i íntim per al dia més important de la vostra vida.",
      },
      corporativo: {
        title: "Esdeveniments Corporatius",
        desc: "Presentacions de producte, sopars de gala i reunions executives en un marc incomparable.",
      },
      coctel: {
        title: "Còctels & Recepcions",
        desc: "Recepcions elegants entre jardins i arquitectura històrica.",
      },
      exposicion: {
        title: "Exposicions & Desfiles",
        desc: "Un escenari artístic natural per a mostres de moda, art i cultura.",
      },
      privado: {
        title: "Celebracions Privades",
        desc: "Aniversaris i reunions familiars d'alt nivell.",
      },
      capacidad: {
        title: "Capacitats per Espai",
        espacio: "Espai",
        banquete: "Banquet",
        coctel: "Còctel",
        rows: [
          ["Planta + Jardí", "150", "180"],
          ["Planta sencera", "80", "120"],
          ["Jardí", "100", "150"],
          ["Sala Noble", "60", "140"],
          ["Sala Kubala", "20", "40"],
          ["Sala Foronda", "20", "40"],
        ],
      },
    },
    galeria: {
      caption: "Galeria",
      heading: "Imatges que parlen per si soles",
    },
    servicios: {
      caption: "Serveis",
      heading: "Tot el que necessites per a una trobada perfecta",
      items: [
        {
          title: "Coordinació d'Esdeveniments",
          desc: "Acompanyem cada detall de l'esdeveniment des de la primera visita fins al darrer brindis.",
        },
        {
          title: "Càtering Premium",
          desc: "Gastronomia d'autor amb ingredients de temporada i presentació impecable.",
        },
        {
          title: "Disseny Floral",
          desc: "Decoració floral artística integrada amb la natura del jardí.",
        },
        {
          title: "So & Música",
          desc: "Equip de so professional i opcions de música en directe.",
        },
        {
          title: "Aparcament & Accés",
          desc: "Informació sobre accés, aparcament proper i accessibilitat per a tots els convidats.",
        },
        {
          title: "Proveïdors Premium",
          desc: "Xarxa de partners exclusius seleccionats per la seva qualitat i experiència.",
        },
      ],
    },
    testimonios: {
      caption: "Testimonis",
      heading: "El que diuen els nostres clients",
      items: [
        {
          text: "Un lloc preciós, romàntic i ben conservat. L'atenció va ser exquisida i el jardí, simplement màgic. Una experiència que no oblidarem.",
          author: "Marta & Pau",
          role: "Noces a Torre Amat",
        },
        {
          text: "Vam organitzar la presentació de la nostra nova col·lecció aquí i l'espai va transmetre exactament el luxe i l'exclusivitat que buscàvem. Perfecte.",
          author: "Equip Creatiu",
          role: "Esdeveniment Corporatiu",
        },
        {
          text: "L'ambient és únic a Barcelona. Els jardins, l'arquitectura, la llum... tot crea una sensació de calma i elegància que no trobaràs en cap altre lloc.",
          author: "Anna G.",
          role: "Celebració Privada",
        },
        {
          text: "Des del mercat artesanal que vam organitzar fins al sopar privat, Torre Amat sempre supera les expectatives. L'equip és proper i professional.",
          author: "Fundació Cultural",
          role: "Esdeveniment Cultural",
        },
      ],
    },
    ubicacion: {
      caption: "Com Arribar",
      heading: "Torre Amat, Sarrià",
      address: "Barri de Sarrià-Sant Gervasi, Barcelona",
      transport: "Com arribar",
      transport_items: [
        { icon: "Train", label: "FGC", desc: "Ferrocarrils Generalitat de Catalunya (L6, S2, S1) — estació Sarrià (5 min a peu)" },
        { icon: "Bus", label: "Bus", desc: "Línies 22, 64, 75 (parada Sarrià)" },
        { icon: "Car", label: "Cotxe", desc: "Aparcament al C/ Pedró de la Creu, 38 · BSM Porta de Sarrià (a 5 minuts a peu)" },
      ],
      private_note: "Espai no obert al públic general. Accés només amb reserva prèvia.",
    },
    contacto: {
      caption: "Contacte",
      heading: "Explica'ns el teu esdeveniment",
      subheading:
        "Escriu-nos i et respondrem en menys de 24 hores per organitzar una visita a l'espai.",
      nombre: "Nom complet",
      email: "Correu electrònic",
      telefono: "Telèfon (opcional)",
      tipo_evento: "Tipus d'esdeveniment",
      fecha: "Data desitjada",
      invitados: "Nombre aproximat de convidats",
      mensaje: "Missatge addicional",
      enviar: "Escriu-nos",
      sending: "Enviant...",
      success: "Missatge enviat. Ens posarem en contacte amb tu aviat.",
      error: "S'ha produït un error. Si us plau, torna a intentar-ho.",
      email_direct: "info@torreamat.com",
      tipos: [
        "Noces",
        "Esdeveniment corporatiu",
        "Còctel / Recepció",
        "Exposició / Desfile",
        "Celebració privada",
        "Altre",
      ],
    },
    footer: {
      tagline: "Patrimoni Històric de Barcelona",
      rights: "Tots els drets reservats",
      private: "Espai privat · Només esdeveniments amb reserva",
    },
  },

  en: {
    nav: {
      espacio: "The Space",
      eventos: "Events",
      galeria: "Gallery",
      servicios: "Services",
      testimonios: "Testimonials",
      contacto: "Contact",
      solicitar: "Request Information",
    },
    hero: {
      tagline: "Modernist Palace · Sarrià · Barcelona",
      heading1: "A space",
      heading2: "like no other, true, beautiful and kind",
      subheading:
        "History, nature and elegance for experiences that last a lifetime.",
      cta1: "Request Information",
      cta2: "Discover the Space",
      private_note: "Private venue · Events by appointment only",
    },
    espacio: {
      caption: "The Space",
      heading: "A palace with soul",
      p1: "Torre Amat is a 19th-century modernist manor house, declared a Barcelona Historic Heritage Site, located in the heart of Sarrià. Its stately architecture, romantic gardens and unique atmosphere make it the perfect setting for extraordinary moments.",
      p2: "Surrounded by centuries-old vegetation and bathed in natural light, Torre Amat offers a sensory experience rarely found elsewhere in the city. The scent of flowers, the sound of wind through the trees and the serene beauty of its architecture create an atmosphere of calm and distinction.",
      p3: "This space is not open to the general public. Every event is unique, cared for with personalised attention and reserved only for those who seek the extraordinary.",
      feature1: "Historic Heritage",
      feature1_desc: "Declared Site of Historic Interest in Barcelona",
      feature2: "Romantic Garden",
      feature2_desc: "Over 100 m² of gardens tended in biodynamic agriculture",
      feature3: "Modernist Architecture",
      feature3_desc: "Original 19th-century modernist manor preserved in all its original splendour",
      feature4: "Private Events Only",
      feature4_desc: "Personalised, exclusive attention",
      download_diptico: "Download Brochure",
      download_plano: "Download Floor Plan",
    },
    eventos: {
      caption: "Event Types",
      heading: "Every celebration, unique",
      subheading:
        "Torre Amat adapts to the nature of each event with the same elegance and dedication.",
      boda: {
        title: "Weddings & Celebrations",
        desc: "A romantic and intimate setting for the most important day of your life.",
      },
      corporativo: {
        title: "Corporate Events",
        desc: "Product launches, gala dinners and executive meetings in an incomparable setting.",
      },
      coctel: {
        title: "Cocktails & Receptions",
        desc: "Elegant receptions among historic gardens and architecture.",
      },
      exposicion: {
        title: "Exhibitions & Fashion Shows",
        desc: "A natural artistic stage for fashion, art and cultural exhibitions.",
      },
      privado: {
        title: "Private Celebrations",
        desc: "High-end birthdays, anniversaries and family gatherings.",
      },
      capacidad: {
        title: "Capacity by Space",
        espacio: "Space",
        banquete: "Banquet",
        coctel: "Cocktail",
        rows: [
          ["Ground floor + Garden", "150", "180"],
          ["Entire floor", "80", "120"],
          ["Garden", "100", "150"],
          ["Sala Noble", "60", "140"],
          ["Sala Kubala", "20", "40"],
          ["Sala Foronda", "20", "40"],
        ],
      },
    },
    galeria: {
      caption: "Gallery",
      heading: "Images that speak for themselves",
    },
    servicios: {
      caption: "Services",
      heading: "Everything you need for a perfect gathering",
      items: [
        {
          title: "Event Coordination",
          desc: "We accompany every detail of your event from the first visit to the last toast.",
        },
        {
          title: "Premium Catering",
          desc: "Signature gastronomy with seasonal ingredients and impeccable presentation.",
        },
        {
          title: "Floral Design",
          desc: "Artistic floral decoration integrated with the garden's natural beauty.",
        },
        {
          title: "Sound & Music",
          desc: "Professional sound equipment and live music options.",
        },
        {
          title: "Parking & Access",
          desc: "Information on access, nearby parking and accessibility for all guests.",
        },
        {
          title: "Premium Suppliers",
          desc: "Exclusive network of partners selected for their quality and experience.",
        },
      ],
    },
    testimonios: {
      caption: "Testimonials",
      heading: "What our clients say",
      items: [
        {
          text: "A beautiful, romantic and well-preserved place. The attention was exquisite and the garden simply magical. An experience we will never forget.",
          author: "Marta & Pau",
          role: "Wedding at Torre Amat",
        },
        {
          text: "We organised the launch of our new collection here and the space conveyed exactly the luxury and exclusivity we were looking for. Perfect.",
          author: "Creative Team",
          role: "Corporate Event",
        },
        {
          text: "The atmosphere is unique in Barcelona. The gardens, the architecture, the light... everything creates a feeling of calm and elegance you won't find anywhere else.",
          author: "Anna G.",
          role: "Private Celebration",
        },
        {
          text: "From the artisan market we organised to the private dinner, Torre Amat always exceeds expectations. The team is warm and professional.",
          author: "Cultural Foundation",
          role: "Cultural Event",
        },
      ],
    },
    ubicacion: {
      caption: "How to Arrive",
      heading: "Torre Amat, Sarrià",
      address: "Sarrià-Sant Gervasi neighbourhood, Barcelona",
      transport: "How to get here",
      transport_items: [
        { icon: "Train", label: "FGC", desc: "Ferrocarrils Generalitat de Catalunya (L6, S2, S1) — Sarrià station (5 min walk)" },
        { icon: "Bus", label: "Bus", desc: "Lines 22, 64, 75 (Sarrià stop)" },
        { icon: "Car", label: "Car", desc: "Parking on C/ Pedró de la Creu, 38 · BSM Porta de Sarrià (5 min walk)" },
      ],
      private_note: "Space not open to the general public. Access by prior appointment only.",
    },
    contacto: {
      caption: "Contact",
      heading: "Tell us about your event",
      subheading:
        "Write to us and we will reply within 24 hours to arrange a visit to the space.",
      nombre: "Full name",
      email: "Email address",
      telefono: "Phone (optional)",
      tipo_evento: "Event type",
      fecha: "Desired date",
      invitados: "Approximate number of guests",
      mensaje: "Additional message",
      enviar: "Write to Us",
      sending: "Sending...",
      success: "Message sent. We will be in touch with you shortly.",
      error: "An error occurred. Please try again.",
      email_direct: "info@torreamat.com",
      tipos: [
        "Wedding",
        "Corporate event",
        "Cocktail / Reception",
        "Exhibition / Fashion Show",
        "Private celebration",
        "Other",
      ],
    },
    footer: {
      tagline: "Barcelona Historic Heritage Site",
      rights: "All rights reserved",
      private: "Private venue · Events by appointment only",
    },
  },
};
